import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export const checkoutOrderTotalItemStyles = (lastChildPosition: number | null = null) => {
    return css`
        font-size: ${TYPOGRAPHY.size.smaller};

        ${() => {
            if (lastChildPosition && lastChildPosition > 1) {
                return css`
                    &:nth-last-child(${lastChildPosition}) {
                        padding: 15px 0 0;
                        @media print {
                            padding: 15px 0 12px;
                        }
                    }

                    &:not(:nth-last-child(${lastChildPosition})) {
                        padding: 15px 0 12px;
                        @media print {
                            padding: 15px 0 12px;
                        }
                        border-bottom: 1px solid ${getColor("common.border")};
                    }
                `;
            }

            return css`
                &:not(:last-child) {
                    padding: 10px 0;
                    @media print {
                        padding: 15px 0 12px;
                    }
                    border-bottom: 1px solid ${getColor("common.border")};
                }
                @media print {
                    padding: 15px 0 12px;
                }
            `;
        }}
    `;
};

export const checkoutStickySpacingStyles = () => {
    return css`
        &:last-child,
        ~ *:last-child {
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-bottom: 73px;
                        `,
                    ],
                    mediaOptions.max,
                )}
        }
    `;
};

export const checkoutStickyWrapperStyles = () => {
    return css`
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        position: fixed;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        z-index: ${get(theme, "zIndex.stickyFooter")};
                        background-color: ${resolveColor("common.background", theme)};
                        padding: 1em;
                        border-top: 1px solid ${resolveColor("common.border", theme)};
                    `,
                ],
                mediaOptions.max,
            )}
    `;
};
